export const LOADER_STATUS = 'boilerplate/Gstr2a2bNew/View/LOADER_STATUS';
export const SUMMARY_TABLE_DATA = 'boilerplate/Gstr2a2bNew/View/SUMMARY_TABLE_DATA';
export const PROCESSED_TABLE_DATA = 'boilerplate/Gstr2a2bNew/View/PROCESSED_TABLE_DATA';
export const DELETED_TABLE_DATA = 'boilerplate/Gstr2a2bNew/View/DELETED_TABLE_DATA';
export const DOC_LEVEL_DATA = "boilerplate/Gstr2a2bNew/View/DOC_LEVEL_DATA";
export const TOTAL_PAGES_PROCESSED = "boilerplate/Gstr2a2bNew/View/TOTAL_PAGES_PROCESSED";
export const TOTAL_PAGES_DELETED = "boilerplate/Gstr2a2bNew/View/TOTAL_PAGES_DELETED";


export const headerColumns = [
  {
    value: "Summary",
    id: "1",
  },
  {
    value: "Processed Data",
    id: "2",
  },
  {
    value: "Deleted",
    id: "3",
  },
];
export const docType = [
  {
    label: "RI",
    value: "RI",
  },
  {
    label: "BS",
    value: "BS",
  },
  {
    label: "C",
    value: "C",
  },
  {
    label: "D",
    value: "D",
  },
  {
    label: "R",
    value: "R",
  },
  {
    label: "RV",
    value: "RV",
  },
  {
    label: "TP",
    value: "TP",
  },
];
export const invoiceType = [
  {
    label: "B2B",
    value: "B2B",
  },
  {
    label: "SEWOP",
    value: "SEWOP",
  },
  {
    label: "DE",
    value: "DE",
  },
  {
    label: "SEWP",
    value: "SEWP",
  },
  {
    label: "B2CL",
    value: "B2CL",
  },
  {
    label: "B2CS",
    value: "B2CS",
  },
  {
    label: "EXWP",
    value: "EXWP",
  },
  {
    label: "EXWOP",
    value: "EXWOP",
  },
];
export const docStatus = [
  {
    label: "O",
    value: "O",
  },
  {
    label: "R",
    value: "R",
  },
];
export const recoStatus = [
  {
    label: "Matched",
    value: "Matched",
  },
  {
    label: "Mismatched",
    value: "Mismatched",
  },
  {
    label: "Not in GTP",
    value: "Not in GTP",
  },
  {
    label: "Not in GSTN",
    value: "Not in GSTN",
  },
];



